<h3 class="ui primary header" >{{ modal.context.fieldData?.name}} field component
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
<div *ngIf="success || error">
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>

<div class="scroll-wrapper" tamsyMargin marginT="20px">

    <app-generic-instance *ngIf="genericModel && genericModel !== 'undefined'" [isEdit]="isEdit "
        [model]="genericModel"
         [selectComponents]="selectComponents"
          [modelForm]="modelForm"
           [error]="error"
        (onClose)="modalClose($event)"
        (onPopup)="modalUp($event)"
         (onEdit)="modalEdit($event)"
          (onSubmit)="modalSubmit($event)">
     </app-generic-instance>

      <app-select-instance *ngIf="selectModel"  [isEdit]="isEdit "
        [model]="selectModel" [selectComponents]="selectComponents" [modelForm]="modelForm" [error]="error"
        (onClose)="modalClose($event)" (onEdit)="modalEdit($event)" (onSubmit)="modalSubmit($event)">
     </app-select-instance>

     <app-group-instance *ngIf="groupModel" [isEdit]="isEdit "
        [model]="groupModel" [selectComponents]="selectComponents" [modelForm]="modelForm" [error]="error"
        (onClose)="modalClose($event)" (onPopup)="modalUp($event)" (onEdit)="modalEdit($event)" (onSubmit)="modalSubmit($event)">
     </app-group-instance>

     <app-calculate-instance *ngIf="calculateModel" [isEdit]="isEdit "
        [model]="calculateModel" [selectComponents]="selectComponents" [modelForm]="modelForm" [error]="error"
        (onClose)="modalClose($event)" (onPopup)="modalUp($event)" (onEdit)="modalEdit($event)" (onSubmit)="modalSubmit($event)">
     </app-calculate-instance>


	</div>

</div>

